module.exports = __webpack_public_path__ + "static/energy_pkg_1-3592b0bab2820fcfff8d95afdebb169c.png";